module.exports = __webpack_public_path__ + "d58ad3a77f60df89e43cefa5cffd9b98.svg";